import React, { ReactNode } from "react";
import { Box, Flex } from "@chakra-ui/react";

interface ScreenshotContainerProps {
	onClick?: () => void;
	clickable: boolean;
	children: ReactNode;
	backgroundColor?: string;
}

const ScreenshotContainer: React.FC<ScreenshotContainerProps> = ({
	onClick,
	clickable,
	children,
	backgroundColor,
}: ScreenshotContainerProps) => {
	return (
		<Flex
			backgroundColor={backgroundColor}
			style={{
				boxShadow: "0px 1px 1px 0px #00000040",
				justifyContent: "center",
				overflow: "hidden",
				aspectRatio: "16 / 9",
				width: "100%",
				borderRadius: "4px",
			}}
		>
			<Box
				onClick={onClick}
				className={clickable ? "clickable" : undefined}
				style={{
					cursor: clickable ? "pointer" : "default",
					boxShadow: "0px 0px 1px 0px #00000033",
					height: "100%",
					width: "100%",
					borderRadius: "4px",
				}}
			>
				{children}
			</Box>
		</Flex>
	);
};

export default ScreenshotContainer;
